import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GlobalSearchState, globalSearchReducerKey } from './global-search.reducer';

export const selectGlobalSearchFeature = createFeatureSelector<GlobalSearchState>(globalSearchReducerKey);

export const selectGlobalSearchSearchText = createSelector(selectGlobalSearchFeature, (state) => {
   return state?.searchText;
});

export const selectAccountSearchCallState = createSelector(selectGlobalSearchFeature, (state) => {
   return state.accountSearchCallState;
});

export const selectPhoneNumberSearchCallState = createSelector(selectGlobalSearchFeature, (state) => {
   return state.phoneNumberSearchCallState;
});

export const selectDeviceSearchCallState = createSelector(selectGlobalSearchFeature, (state) => {
   return state.deviceSearchCallState;
});

export const selectSoftphoneUsernameSearchCallState = createSelector(selectGlobalSearchFeature, (state) => {
   return state.softphoneUserNamesSearchCallState;
});

export const selectAccountsSearchResults = createSelector(selectGlobalSearchFeature, (state) => {
   return state.accounts;
});

export const selectDevicesSearchResults = createSelector(selectGlobalSearchFeature, (state) => {
   return state.devices;
});

export const selectPhoneNumbersSearchResults = createSelector(selectGlobalSearchFeature, (state) => {
   return state.phoneNumbers;
});

export const selectSoftphoneUsernamesSearchResults = createSelector(selectGlobalSearchFeature, (state) => {
   return state.softphoneUserNames;
});
